/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener
 * crm-screener
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CreateLeadAssignmentRequest
 */
export interface CreateLeadAssignmentRequest {
    /**
     * 
     */
    user_id: string;
    /**
     * 
     */
    role: CreateLeadAssignmentRequestRoleEnum;
}


/**
 * @export
 */
export const CreateLeadAssignmentRequestRoleEnum = {
    Owner: 'OWNER',
    Liaison: 'LIAISON',
} as const;
export type CreateLeadAssignmentRequestRoleEnum = typeof CreateLeadAssignmentRequestRoleEnum[keyof typeof CreateLeadAssignmentRequestRoleEnum];


/**
 * Check if a given object implements the CreateLeadAssignmentRequest interface.
 */
export function instanceOfCreateLeadAssignmentRequest(value: object): value is CreateLeadAssignmentRequest {
    if (!('user_id' in value) || value['user_id'] === undefined) return false;
    if (!('role' in value) || value['role'] === undefined) return false;
    return true;
}

export function CreateLeadAssignmentRequestFromJSON(json: any): CreateLeadAssignmentRequest {
    return CreateLeadAssignmentRequestFromJSONTyped(json, false);
}

export function CreateLeadAssignmentRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateLeadAssignmentRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'user_id': json['user_id'],
        'role': json['role'],
    };
}

export function CreateLeadAssignmentRequestToJSON(json: any): CreateLeadAssignmentRequest {
    return CreateLeadAssignmentRequestToJSONTyped(json, false);
}

export function CreateLeadAssignmentRequestToJSONTyped(value?: CreateLeadAssignmentRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'user_id': value['user_id'],
        'role': value['role'],
    };
}

